export default __webpack_public_path__ + "static/media/EM0730.34I-22032_-15025_0.de54551d.jpg";